import { useSearchParams } from "react-router-dom";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { OrderForm } from "@/components/OrderForm";
import { ShieldCheck, Truck, Wand2 } from "lucide-react";
import { Seo } from "@/components/Seo";
import { crumbs } from "@/config/seo";

export default function Order() {
  const [params] = useSearchParams();

  const assurances = [
    { icon: Wand2, text: "Free photo enhancement before printing" },
    { icon: Truck, text: "Same-day delivery available for +$5" },
    { icon: ShieldCheck, text: "Waterproof, fade & scratch resistant" },
  ];

  return (
    <div data-testid="order-page" className="pt-32">
      <Seo
        title="Order Your Metal Print | MetalMuse Saskatchewan"
        description="Order your custom metal print in minutes. Upload your photo, choose a size and pay a 50% Interac e-Transfer advance. Free photo enhancement, ready-to-hang aluminum, same-day delivery available."
        path="/order"
        keywords="order metal print, custom metal photo, upload photo print, Interac e-Transfer print order, Saskatchewan"
        jsonLd={[crumbs([{ name: 'Home', path: '/' }, { name: 'Order', path: '/order' }])]}
      />
      <section className="container-lux max-w-3xl pb-24">
        <SectionHeader
          eyebrow="Order"
          title="Order Your Metal Print"
          text={params.get("product") ? `You selected: ${params.get("product")}. Fill in your details and upload your photo — we'll confirm everything before printing.` : "Fill in your details and upload your photo — we'll confirm everything personally before printing."}
        />
        <Reveal className="flex flex-wrap gap-3 mb-10">
          {assurances.map((a) => (
            <span key={a.text} className="inline-flex items-center gap-2 text-xs text-[#A1A1A6] bg-[#121212] border border-white/5 rounded-full px-4 py-2">
              <a.icon size={14} className="text-[#00E5FF]" /> {a.text}
            </span>
          ))}
        </Reveal>
        <Reveal delay={0.1}>
          <OrderForm key={params.get("product") || "default"} preselect={params.get("product")} />
        </Reveal>
      </section>
    </div>
  );
}
